// extracted by mini-css-extract-plugin
export var contentWrapper = "thinLenses-module--contentWrapper--xw4O5";
export var header = "thinLenses-module--header--Fv7-u";
export var headerWrapper = "thinLenses-module--headerWrapper--j9krY";
export var lensThicknessPhoto = "thinLenses-module--lensThicknessPhoto--RliIP";
export var thinLensParagraph = "thinLenses-module--thinLensParagraph--CEYI+";